import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { useRootContext, setRsvpContext } from '../partials/context/rootContext';
import Greeting from '../partials/blocks/greeting';
import RoundedContainer from '../partials/components/roundedContainer';
import ScheduleListItem from '../partials/components/scheduleListItem';
import ScheduleList from '../partials/components/scheduleList';
import CTAButton from '../partials/components/ctaButton';
import DividerLine from '../partials/components/dividerLine';
import RoomTimeSelection from '../partials/components/roomTimeSelection';

import wpStyles from '../wordpressStyles';


const Landing = ({ ...props }) => {
    const { rsvpContext, setRsvpContext, scheduleContext } = useRootContext();
    const [isRSVPButtonBusy, setIsRSVPButtonBusy] = useState(false);
    const [thisSchedule, setThisSchedule] = useState([]);

    useEffect(() => {
        let newSchedule = [...scheduleContext];
       
        setThisSchedule(newSchedule);
        
    },[scheduleContext])

    const hasRoomsAvailable = () => {
        for (const room of props.data.rooms){
            if(!room.auto_register && !room.registered)
                return true;
        }
        return false;
    }

    const hasMoreThanMainSession = () => {
        for (const room of props.data.rooms){
            if(!room.auto_register)
                return true;
        }
        return false;
    }

    const roomSignupCTA = () => {
        return (hasRoomsAvailable() ?
            (<Link to="/breakouts" className="p-2 mx-2">
                <CTAButton text="Sign up for Breakout Rooms" />
            </Link>)
                :
            (''));
    };

    const postRSVP = () => {
        setIsRSVPButtonBusy(true);

        fetch(
            launchframe.ajax_url + '?action=register_for_event&&event_id=' + props.data.current_event + '&rsvp=true',
            {
                method: 'POST'
            }
        )
            .then(res => res.json())
            .then(
                result => {
                    setIsRSVPButtonBusy(false);
                    setRsvpContext(true);
                    window.location.reload(false);
                },

                error => {
                    setIsRSVPButtonBusy(false);
                }
            );
    };

    let heroText = props.data.rsvp_info ? (
        <div
            dangerouslySetInnerHTML={{
                __html: props.data.rsvp_info.rsvp_yes_title
                    .split('%%date%%')
                    .join(
                        `<span class="text-red-500">${moment(props.data.event.start).format(
                            'MMMM Do, YYYY'
                        )} at ${moment(props.data.event.start).format('h:mma')} ET</span>`
                    )
            }}
        />
    ) : '';

    if (!rsvpContext) {
        heroText = props.data.rsvp_info ? (
            <div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: props.data.rsvp_info.rsvp_no_title
                            .split('%%date%%')
                            .join(
                                `<span class="text-red-500">${moment(props.data.event.start).format(
                                    'MMMM Do, YYYY'
                                )}</span>`
                            )
                    }}
                />
            </div>
        ) : '';
    }
    return (
        <div className="px-4 font-sans container">
            <Greeting 
                firstName={props.data.attendee.first_name}
                location={props.data.event.location_below_greeting ? props.data.attendee.location : 'Non-Regional'}
            />
            {/* <div className="flex px-10 py-8 lg:py20 text-3xl lg:text-5xl container font-sans text-center justify-center font-bold"  style={wpStyles.textColor2}>
                <div className="flex max-w-5xl">{heroText}</div>
            </div> */}
            {rsvpContext && (
                <h3 className="text-center text-lg sm:text-2xl text-red-500 font-bold px-4 pt-4 pb-6 lg:pb-20"  style={wpStyles.textColor1}>
                    {props.data.rsvp_info ? props.data.rsvp_info.rsvp_yes_subtitle : ''}
                </h3>
            )}
            <div className="relative flex flex-col container">
                
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.data.event.pre_event_message
                        }}
                    />

                {props.data.display_rsvp && (<>

                    <ScheduleListItem
                        titleText={props.data.event.main_event_name}
                        descriptionText={props.data.event.main_event_description}
                        buttonText={rsvpContext ? '' : 'RSVP Yes'}
                        timeText={rsvpContext ? `${moment(props.data.event.start).format('h:mma')}` : ''}
                        timezoneText={rsvpContext ? 'ET' : ''}
                        onButtonClick={() => {
                            postRSVP();
                        }}
                        busy={isRSVPButtonBusy}
                        hideLabel={ ! props.data.event.send_rsvp_email } /* Don't show times when no RSVP emails are being sent, this is likely a simulcast across multiple timezones */
                    />

                    <RoomTimeSelection />

                    {!rsvpContext && (
                        <h3 className="text-center text-lg sm:text-2xl text-red-500 font-boldpy-8 lg:py20"  style={wpStyles.textColor1}>
                            {props.data.rsvp_info ? props.data.rsvp_info.rsvp_no_subtitle : ''}
                        </h3>
                    )}

                </>)}

                <div className="flex w-full justify-center py-8">
                    {roomSignupCTA()}
                </div>

                {hasMoreThanMainSession() ? (<div>
                    
                    {/* <DividerLine horizontal dashed /> */}
                    
                    <h3 className="text-3xl lg:text-4xl font-bold text-gray-700 pt-0">My Schedule</h3>

                    {thisSchedule.length > 0 ? (
                        <div className="pb-8 font-sans ">
                            <ScheduleList
                                className="space-y-4"
                                items={thisSchedule}
                                hideButtons={true}
                            />
                            <div className="flex w-full justify-center pt-8">
                                {roomSignupCTA()}
                            </div>
                        </div>
                    ) : (
                        <RoundedContainer className="flex-wrap py-8">
                            <div className="w-full">
                                <h3 className="text-center text-xl sm:text-3xl lg:text-4xl font-bold text-gray-700">
                                    If you haven't signed up for master classes, maybe it's time to do so!
                                </h3>
                            </div>
                            <div className="flex w-full justify-center pt-8">
                                {roomSignupCTA()}
                            </div>
                        </RoundedContainer>
                    )}
                </div>) : ""}
                {/* <div className="flex flex-wrap justify-center py-8 lg:py20">
                    <h3 className="w-full text-centertext-lg sm:text-2xl font-bold text-gray-700 block">
                        Have a specific question?
                    </h3>
                    <div className="w-full flex justify-center">
                        <p className="text-center py-4 max-w-3xl">
                            Express Support appointments are available Wednesday (10/21) through Friday (10/23) to
                            connect one-on-one with specialty consultants and subject matter experts.
                        </p>
                    </div>
                    <Link to="/expressSupport">
                        <CTAButton text="Sign up for Express Support" />
                    </Link>
                </div> */}
            </div>
        </div>
    );
};

export default Landing;
